exports.PARCELS_ALLOWED_LENGTH =
  "Count of parcels should be less or equal to numberOfParcels value";
